<div class="header-bar flex justify-content-between align-items-center">
  <h1>Driver Referral Link Admin</h1>
  <button
    pButton
    class="ui-button-primary"
    label="Save"
    (click)="saveSettings()"
    [disabled]="saveDisabledReason"
    [pTooltip]="saveDisabledReason"
    style="width: 150px"
  ></button>
</div>
<div class="content-container bg-white style2023">
  <div *ngIf="!loading && formErrors && formErrors.length > 0">
    <ul class="mt-0 text-red-500">
      <li *ngFor="let error of formErrors" [innerHTML]="error"></li>
    </ul>
    <div class="horizontal-divider"></div>
  </div>
  <div class="mb-4" *ngIf="loading">
    <p-progressBar mode="indeterminate" class="ui-progressbar-indeterminate"></p-progressBar>
  </div>
  <p-accordion styleClass="mb-4">
    <p-accordionTab header="Template Variables">
      <div *ngFor="let variable of templateVariables" class="grid">
        <div class="col">
          <code class="inline-code">{{ variable.name }}</code>
        </div>
        <div class="col font-bold">{{ variable.description }}</div>
      </div>
    </p-accordionTab>
  </p-accordion>
  <form [formGroup]="settingsForm">
    <ng-container *ngFor="let group of formLayout; let last = last">
      <div class="grid" *ngFor="let control of group.controls">
        <div class="col-3 font-bold" style="align-content: center">
          {{ controlLabels[control.name] }}
          <i
            class="fa fa-info-circle ml-1"
            [escape]="false"
            *ngIf="controlTooltips[control.name]"
            [pTooltip]="controlTooltips[control.name]"
          ></i>
        </div>
        <div class="col">
          <div class="input-group" style="height: 35px">
            <div class="input-group-item">
              <input
                pInputText
                [name]="control.name"
                [type]="control.type || 'text'"
                [min]="control.min || null"
                [max]="control.max || null"
                [step]="control.type === 'number' ? 1 : null"
                [placeholder]="controlLabels[control.name]"
                [formControlName]="control.name"
                (change)="control?.onChange($event)"
                [disabled]="loading"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="horizontal-divider"></div>
    </ng-container>
    <div *ngIf="!loading && currentSettings && currentSettings.updated">
      <b class="text-md">Last updated:</b>
      <code class="inline-code m-1">{{ currentSettings.updated | date : 'medium' }}</code> by
      <code class="inline-code m-1">{{ currentSettings.updatedBy }}</code>
    </div>
  </form>
</div>
